import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useOrderItem, { useOrderItemForm } from '@hooks/useOrderItem'
import useStatuses from '@hooks/useStatuses'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

const MODAL_KEY = 'ManageProviderOrderItemStatusModal'

const selectableStatusKeys = ['approved', 'urgent', 'processing', 'awaiting_review', 'delivered']

export type ModalCallbacks = {
  closeModal: () => void,
  updateProviderOrderItem: (payload: HandleCallbackActionParams) => void,
}

interface ModalProps {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageProviderOrderItemStatusModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, updateProviderOrderItem } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { orderItem: initOrderItem } = modalPayload

  const orderItemPayload = useOrderItem(initOrderItem)
  const {
    callbacks: {
      updateOrderItem: updateFn,
    },
    orderItem,
    updating,
  } = orderItemPayload

  const orderItemFormPayload = useOrderItemForm(orderItem, { validateOn: 'change' })
  const {
    entityState,
    entityState: {
      status_id,
    },
    handlers,
  } = orderItemFormPayload

  const updateOrderItemPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Order Item Updated',
  }
  const { filteredStatuses } = useStatuses({ filters: { status_keys: selectableStatusKeys } })

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Order Item" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Status">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="status_id"
              value={status_id}
              {...handlers}
            >
              {filteredStatuses.map(status => <option value={status.id}>{status.title}</option>)}
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateProviderOrderItem(updateOrderItemPayload)}
          size="large"
        >
          Save
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageProviderOrderItemStatusModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
